import { render, staticRenderFns } from "./ModalAddSupplier.vue?vue&type=template&id=63516c9e&"
import script from "./ModalAddSupplier.vue?vue&type=script&lang=js&"
export * from "./ModalAddSupplier.vue?vue&type=script&lang=js&"
import style1 from "./ModalAddSupplier.vue?vue&type=style&index=1&id=63516c9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports